import { getAuthSessions } from '../auth/authApi'
import { clasolSuiteApi } from '../axiosConfig'
import { buildListParams, withApplicationCode } from '../apiHelpers'

export const getUserAuditEvents = async (applicationCode, params) => {
  const { data } = await clasolSuiteApi.get('/audit', {
    params: buildListParams({ sortDirection: 'desc', ...params }),
    ...withApplicationCode(applicationCode),
  })
  return data
}

export const getUserSessions = getAuthSessions
